import { useParams } from "react-router-dom";
import { useFindingOnAsset } from "~/pages/findings/FindingOnAsset/hooks";
import {
  isCheckFinding,
  isGenericFinding,
} from "~/pages/findings/FindingOnAsset/utils";
import { AssetCheckRemediation } from "~/pages/findings/FindingOnAsset/components/AssetRemediation/AssetCheckRemediation";
import { Remediation } from "~/components/Remediation/Remediation";

export function AssetRemediation() {
  const { vulnId = "", advisoryId = "" } = useParams();
  const { finding } = useFindingOnAsset();

  if (isGenericFinding(finding)) return;

  return (
    <>
      {isCheckFinding(finding) ? (
        <AssetCheckRemediation />
      ) : (
        <Remediation
          findingId={vulnId || advisoryId}
          scopeMrn={finding?.asset?.mrn}
          isAssetContext
          findingMrn={finding?.mrn}
        />
      )}
    </>
  );
}
